<template>
  <div>
    <UserComments />
  </div>
</template>

<script>
import appConfig from '@/app.config'
import UserComments from '../../../components/dadban/comments/UserComments.vue'

export default {
  page: {
    title: 'مدیریت نظرات',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-user-comments',
  components: { UserComments },
}
</script>
